import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/activityReportActions'
import * as api from '../../../api/reports/general/activityReport'

function* activityReportGetOverview(action) {
  try {
    const payload = yield call(api.getOverview, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_OVERVIEW.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_OVERVIEW.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetOverviewByUser(action) {
  try {
    const payload = yield call(api.getOverviewByUser, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetContactsAdded(action) {
  try {
    const payload = yield call(api.getContactsAdded, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetCompaniesAdded(action) {
  try {
    const payload = yield call(api.getCompaniesAdded, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetLeadsAdded(action) {
  try {
    const payload = yield call(api.getLeadsAdded, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_LEADS_ADDED.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_LEADS_ADDED.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetJobsAdded(action) {
  try {
    const payload = yield call(api.getJobsAdded, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_JOBS_ADDED.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_JOBS_ADDED.FAILED,
      message: e.message || e
    })
  }
}

function* activityReportGetEstimatesAdded(action) {
  try {
    const payload = yield call(api.getEstimatesAdded, action.filters)
    yield put({ type: constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchActivityReportGetOverview() {
  yield takeLatest(constants.ACTIVITY_REPORT_GET_OVERVIEW.ACTION, activityReportGetOverview)
}

function* watchActivityReportGetOverviewByUser() {
  yield takeLatest(
    constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.ACTION,
    activityReportGetOverviewByUser
  )
}

function* watchActivityReportGetContactsAdded() {
  yield takeLatest(
    constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.ACTION,
    activityReportGetContactsAdded
  )
}

function* watchActivityReportGetCompaniesAdded() {
  yield takeLatest(
    constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.ACTION,
    activityReportGetCompaniesAdded
  )
}

function* watchActivityReportGetLeadsAdded() {
  yield takeLatest(constants.ACTIVITY_REPORT_GET_LEADS_ADDED.ACTION, activityReportGetLeadsAdded)
}

function* watchActivityReportGetJobsAdded() {
  yield takeLatest(constants.ACTIVITY_REPORT_GET_JOBS_ADDED.ACTION, activityReportGetJobsAdded)
}

function* watchActivityReportGetEstimatesAdded() {
  yield takeLatest(
    constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.ACTION,
    activityReportGetEstimatesAdded
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchActivityReportGetOverview),
    fork(watchActivityReportGetOverviewByUser),
    fork(watchActivityReportGetContactsAdded),
    fork(watchActivityReportGetCompaniesAdded),
    fork(watchActivityReportGetLeadsAdded),
    fork(watchActivityReportGetJobsAdded),
    fork(watchActivityReportGetEstimatesAdded)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/activityReportSaga.js